module.exports = {
  audio: {
    play: 'Audio abspielen',
    pause: 'Audio pausieren',
  },
  filterLabel: {
    document_word: '.docx (Word)',
    document_image: '.jpeg .png .gif (Bild)',
    document_pdf: '.pdf',
    document_powerpoint: '.pptx (Powerpoint)',
    document_sheet: '.xls (Excel)',
    audio: 'Audio',
    no_attachment: 'Textinhalte',
    document: 'Dokumente',
    wbt: 'Web Based Training',
    video: 'Video',
  },
  materialcount: '1 Datei | %{n} Dateien',
  wbt: {
    status: {
      passed: 'Bestanden',
      completed: 'Abgeschlossen',
      failed: 'Nicht Bestanden',
    },
    table: {
      date: 'Datum',
      result: 'Ergebnis',
      status: 'Status',
    },
    no_results: 'Keine Einträge vorhanden',
  },
  passed: 'Bestanden',
  wbt_is_processing: 'Diese Datei wird gerade verarbeitet, bitte versuche es später erneut.',
  sortLabels: {
    name_asc: 'Alphabetisch (A-Z)',
    name_desc: 'Alphabetisch (Z-A)',
    published_at_asc: 'Datum (älteste zuerst)',
    published_at_desc: 'Datum (neuste zuerst)',
  },
  types: {
    audio: 'Audio',
    no_attachment: 'Textinhalt',
    document: 'Dokument',
    document_word: 'Word Dokument',
    document_sheet: 'Excel',
    document_image: 'Bild',
    link: 'Link',
    document_pdf: 'PDF',
    document_powerpoint: 'Powerpoint',
    video: 'Video',
    wbt: 'WBT',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    published_at_asc: 'Älteste',
    published_at_desc: 'Neuste',
    name_desc: 'Z-A',
  },
  search_learningmaterials: 'Dateien suchen',
  latest: 'Neuste',
  with_percentage: 'mit %{score}%',
  startButtonLabel: {
    document: 'Dokument herunterladen',
    document_word: 'Dokument herunterladen',
    document_powerpoint: 'Powerpoint herunterladen',
    open_office: 'Dokument öffnen',
    document_image: 'Bild öffnen',
    link: 'Link öffnen',
    document_pdf: 'PDF öffnen',
    wbt: 'WBT starten',
    audio: 'Audio starten',
    video: 'Video starten',
    download_file: '%{title} herunterladen',
    open_pdf: 'PDF öffnen %{title}',
  },
  go_to_learningmaterials: 'Datei öffnen',
  open_wbt_in_browser: 'WBT im Browser öffnen',
  no_wbt_on_ios: 'Leider ist derzeit die Wiedergabe von WBTs in der Store-App unter iOS nicht möglich. Bitte siehe dir den Inhalt in deinem Browser an.',
  files: 'Dateien',
  new: 'Neu',
  latest_learningmaterials: 'Neu in der Mediathek',
  subfolder: 'Unterordner',
  all_categories: 'Alle Ordner A-Z',
  last_viewed: 'Zuletzt aufgerufen',
}
